import * as React from "react";
import Component from "../../AbstractComponent";
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';

// import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
// import {
//   TimePicker,
//   MuiPickersUtilsProvider,
// } from '@material-ui/pickers';
// import MomentUtils from '@date-io/moment';

class NoteCreate extends Component {

  protected ref: any;

  public state = {
    note: "",
    error: "",
    notificationDate: new Date(),
    notificationTime: new Date(),
    showPickers: false
  };

  constructor(public props) {
    super(props);
  }

  public focusInput(): any {
    this.ref.focus();
  }

  public create = (): void => {
    if (this.state.note.length === 0 || this.state.note.trim() == '') {
      this.setState({
        error: this.trans("please-enter-a-note")
      });
      return;
    }

    const snoozeDate = !!this.state.notificationDate && !!this.state.notificationTime ? new Date(
      this.state.notificationDate.getFullYear(),
      this.state.notificationDate.getMonth(),
      this.state.notificationDate.getDate(),
      this.state.notificationTime.getHours(),
      this.state.notificationTime.getMinutes()
    ) : null;

    this.props.createNote(this.state.note, this.state.showPickers ? snoozeDate : null);
  }

  public cancel = () => {
    this.props.onCancel.call(this);
  }

  public switchSetTimeAndNotification = () => {
    this.setState({
      showPickers: !this.state.showPickers
    })
  }

  public handleDateChange = (time) => {
    this.setState({ notificationTime: time.toDate() })
  }

  public render() {
    return (
      <div className="note-form-container create" style={{borderBottom: "1px solid rgba(0, 0, 0, 0.1)"}}>
        <TextField
                  autoComplete="off"
          inputProps={{ref: input => this.ref = input}}
          className="form-element full-size"
          multiline={true}
          type="text"
          rowsMax={10}
          label={this.state.note.length > 0 ? this.trans("note") : this.trans("type-a-note")}
          value={this.state.note}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
          autoFocus={true}
          style={{marginTop: "-10px", marginBottom: "10px"}}
          variant="standard"
          error={!!this.state.error}
        />
        {!!this.state.error && <div className="component-error-text">{this.state.error}</div>}

        {/* <FormControlLabel
          control={
            <Checkbox
              checked={this.state.showPickers}
              onChange={this.switchSetTimeAndNotification}
              color="primary"
            />
          }
          label={this.trans("label-set-time-notification")}
        /> */}

        {/* {this.state.showPickers && (
          <div>
            <div className="note-task-container" style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
              <div style={{width: "68%"}}>
                <DatePickerComponent
                  {...this.props}
                  className="scroll-to-notificationDate"
                  label={this.trans("label-date")}
                  initialDate={this.state.notificationDate}
                  onChange={date => this.setState({ notificationDate: date })}
                  minDate={new Date()}
                  minDatePlusDays={0}
                  clearButton={true}
                  error={this.getErrorFor("notificationDate")}
                />
              </div>
              <div style={{width: "32%", marginBottom: "13px", marginLeft: "15px"}}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <TimePicker
                    ampm={false}
                    format="HH:mm"
                    value={this.state.notificationTime}
                    onChange={this.handleDateChange}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
            <p style={{margin: "10px 0", fontSize: "12px", color: "gray"}}>{this.trans("to-set-a-notification")}</p>
          </div>
        )} */}

        <div className="buttons task-buttons" style={{width: "100%", display: "flex", justifyContent: "flex-end", marginTop: "10px"}}>
          <Button
            color="primary"
            onClick={() => {
              this.setState({
                note: "",
                error: "",
                notificationDate: new Date(),
                notificationTime: new Date(),
                showPickers: false
              }, this.cancel)}}
            className={"full-size"}
            style={{marginRight: "10px"}}
          >
            {this.trans("button-cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.create}
            className={"full-size"}
          >
            {this.trans("button-add")}
          </Button>
        </div>
      </div>
    );
  }
}

export { NoteCreate };
